export default "__VITE_ASSET__4r78Ud3r__"